module.exports = __webpack_public_path__ + "static/scale-model-of-west-jordan-utah-edaa36735bbbc526055aab2c5a7eccca.png";